import React from 'react';
import { Typography, Button } from 'antd';
import styles from './IPPSignup.module.css';

const { Title, Paragraph } = Typography;

interface IPPSignupSectionProps {
  readonly onLogin: () => void;
}

function IPPSignupSection(props: Readonly<IPPSignupSectionProps>) {
  const { onLogin } = props;
  return (
    <div className={styles.pageWrapper} data-testid="login-page">
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.heroPhoto} />

        <div className={styles.heroPanel}>
          <div className={styles.heroCard}>
            <img src="/Logo-onwhite.png" alt="Nova Scotia Power" className={styles.heroLogo} />

            <Title level={1} className={styles.heroTitle}>
              Windvoice Calculator
            </Title>

            <div className={styles.authButtons}>
              <Button type="primary" className={styles.signInButton} onClick={onLogin} data-testid="login-button">
                Sign In
              </Button>
            </div>

            <Paragraph className={styles.heroParagraph}>Streamlining renewable energy invoicing</Paragraph>
          </div>
        </div>
      </section>
    </div>
  );
}

export default IPPSignupSection;
